import { AcademicStatusDisplay } from '../constants';
import { Typography } from 'antd';

interface AcademicStatusCellProps {
  status?: string;
  statusConfig?: Record<string, AcademicStatusDisplay>;
}

const STATUS_CONFIG: Record<string, AcademicStatusDisplay> = {
  approved: {
    label: 'Aprovado',
    dotClassName: 'bg-emerald-500'
  },
  failed: {
    label: 'Reprovado',
    dotClassName: 'bg-rose-500'
  },
  in_progress: {
    label: 'Em andamento',
    dotClassName: 'bg-amber-400'
  },
  attendance_failed: {
    label: 'Reprovado por frequência',
    dotClassName: 'bg-rose-500'
  },
  progress_failed: {
    label: 'Reprovado por progresso',
    dotClassName: 'bg-rose-500'
  },
  exempted: {
    label: 'Isento por aproveitamento',
    dotClassName: 'bg-amber-400'
  },
  cancelled: {
    label: 'Cancelado',
    dotClassName: 'bg-slate-400'
  },
  inactive: {
    label: 'Inativo',
    dotClassName: 'bg-slate-400'
  }
};

export const AcademicStatusCell = ({
  status,
  statusConfig = STATUS_CONFIG
}: AcademicStatusCellProps) => {
  const config = statusConfig[status ?? ''] || statusConfig.in_progress;

  return (
    <div className="flex items-center gap-2">
      <span
        className={`inline-block h-2.5 w-2.5 shrink-0 rounded-full ${config.dotClassName}`}
      />
      <Typography.Text className="text-sm">{config.label}</Typography.Text>
    </div>
  );
};
